import React from 'react'
import Grid from '@mui/material/Grid2'
import {Typography} from '@mui/material'
import {formatPrice} from '../../../../../app/core/utils/utility'

type TChequeItemType = {
  accountNumber: string //
  amount: number //
  backDate: string //
  bankCode: number
  branchCode: string
  branchDescription?: string //
  date?: string
  id: string
  number?: string
}

const HeaderChequeItem = ({chequeItems}: {chequeItems: TChequeItemType[]}) => {
  return (
    <div className='w-100 d-flex flex-column'>
      {chequeItems &&
        chequeItems?.map((item) => (
          <Grid
            size={12}
            mb={1}
            width={'100%'}
            sx={{
              border: '0.5px solid #EAECF0',
              borderRadius: '8px',
              boxShadow: '0px 0px 10px 0px #1018280D',
            }}
          >
            <Grid
              p={2}
              width={'100%'}
              display={'flex'}
              justifyContent={'space-between'}
              sx={{
                background: 'rgba(7, 148, 85, 0.1)',
                border: '1px solid #EAECF0',
                borderRadius: '8px 8px 0px 0px',
              }}
            >
              <Grid display={'flex'} flexDirection={'column'}>
                <Typography variant='caption' fontWeight={'bold'} fontSize={'12px'}>
                  {item?.branchDescription}
                </Typography>
              </Grid>
              {/* <Grid
            height={'24px'}
            width={'87px'}
            textAlign={'center'}
            sx={{
              backgroundColor: facilityStatusColor[item?.facilityStatus].bgClass,
              borderRadius: '4px',
            }}
          >
            <Typography
              variant='button'
              color={facilityStatusColor[item?.facilityStatus].textClass}
              fontSize={'12px'}
            >
              {facilityStatusColor[item?.facilityStatus].label}
            </Typography>
          </Grid> */}
            </Grid>
            <Grid
              p={2}
              width={'100%'}
              display={'flex'}
              justifyContent={'space-between'}
              sx={{
                border: '1px solid #EAECF0',
              }}
            >
              <Grid display={'flex'} flexDirection={'column'}>
                <Typography variant='caption' fontWeight={'bold'} fontSize={'13px'}>
                  شماره حساب :
                </Typography>
              </Grid>
              <Grid display={'flex'} flexDirection={'column'}>
                <Typography variant='caption' fontWeight={'bold'} fontSize={'13px'}>
                  {item?.accountNumber}
                </Typography>
              </Grid>
            </Grid>
            <Grid px={2} pt={1} width={'100%'} display={'flex'} justifyContent={'space-between'}>
              <Grid display={'flex'} flexDirection={'column'}>
                <Typography variant='caption' fontWeight={'bold'} fontSize={'13px'}>
                  تاریخ برگشت :
                </Typography>
              </Grid>
              <Grid display={'flex'} flexDirection={'column'}>
                <Typography variant='caption' fontWeight={'bold'} fontSize={'13px'}>
                  {`${item?.backDate.slice(0, 4)}/${item?.backDate.slice(
                    4,
                    6
                  )}/${item?.backDate.slice(6, 8)}`}
                </Typography>
              </Grid>
            </Grid>
            <Grid px={2} pt={1} width={'100%'} display={'flex'} justifyContent={'space-between'}>
              <Grid display={'flex'} flexDirection={'column'}>
                <Typography variant='caption' fontWeight={'bold'} fontSize={'13px'}>
                  مبلغ چک :
                </Typography>
              </Grid>
              <Grid display={'flex'} flexDirection={'column'}>
                <Typography variant='caption' fontWeight={'bold'} fontSize={'13px'}>
                  {formatPrice(item?.amount)}
                </Typography>
              </Grid>
            </Grid>
            <Grid px={2} pt={1} width={'100%'} display={'flex'} justifyContent={'space-between'}>
              <Grid display={'flex'} flexDirection={'column'}>
                <Typography variant='caption' fontWeight={'bold'} fontSize={'13px'}>
                  کد بانک :
                </Typography>
              </Grid>
              <Grid display={'flex'} flexDirection={'column'}>
                <Typography variant='caption' fontWeight={'bold'} fontSize={'13px'}>
                  {item?.bankCode}
                </Typography>
              </Grid>
            </Grid>
            <Grid px={2} pt={1} width={'100%'} display={'flex'} justifyContent={'space-between'}>
              <Grid display={'flex'} flexDirection={'column'}>
                <Typography variant='caption' fontWeight={'bold'} fontSize={'13px'}>
                  کد شعبه :
                </Typography>
              </Grid>
              <Grid display={'flex'} flexDirection={'column'}>
                <Typography variant='caption' fontWeight={'bold'} fontSize={'13px'}>
                  {item?.branchCode}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        ))}
    </div>
  )
}

export default HeaderChequeItem
